import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class TranslationCacheBusterService {
    getVersion(): string {
        return require('../../../../../../package.json').version;
    }

    getTranslationUrl(basePath: string, lang: string): string {
        const version = this.getVersion();
        return `${basePath}${lang}.json?v=${version}`;
    }
}
